import { render, staticRenderFns } from "./InputDateBirth.vue?vue&type=template&id=4d719a46"
import script from "./InputDateBirth.vue?vue&type=script&lang=js"
export * from "./InputDateBirth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports